import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin } from 'lucide-react';

const FooterImpl = ({ isMuted, playIgnition }) => (
  <footer className="relative z-10 py-12 flex flex-col items-center gap-6 text-white/40 text-xs">
    <div className="flex gap-4 sm:gap-6">

      <motion.a
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.95 }}
        onHoverStart={() => !isMuted && playIgnition(2)}
        href="https://github.whynikhil.xyz"
        target="_blank"
        rel="noreferrer"
        className="w-12 h-12 rounded-full border border-white/10 bg-black/40 backdrop-blur-xl flex items-center justify-center hover:bg-white hover:text-black transition-all hover:shadow-[0_0_20px_rgba(255,255,255,0.3)]"
      >
        <Github size={20} />
      </motion.a>

      <motion.a
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.95 }}
        onHoverStart={() => !isMuted && playIgnition(2)}
        href="https://linkedin.whynikhil.xyz"
        target="_blank"
        rel="noreferrer"
        className="w-12 h-12 rounded-full border border-white/10 bg-black/40 backdrop-blur-xl flex items-center justify-center hover:bg-white hover:text-black transition-all hover:shadow-[0_0_20px_rgba(255,255,255,0.3)]"
      >
        <Linkedin size={20} />
      </motion.a>

    </div>

    <span className="tracking-widest opacity-40">
      © {new Date().getFullYear()} NiKHiL
    </span>

  </footer>
);

export const Footer = React.memo(FooterImpl);
